module.exports = __webpack_public_path__ + "static/media/header-bg-one@2x.df323a80.png";